/**
 * Which release and build is running, at the foot of webmail's folders and
 * of the console's menu: what to quote when reporting a problem, and how to
 * tell that an update has arrived. In the desktop app it says so, with the
 * app's version (its engine answers /api/about; webmail's server does not).
 */

import { useEffect, useState } from 'react';

import { BUILD } from '../build';

let appVersion: Promise<string | null> | null = null;

/** The desktop app's version, or null in a browser. Asked once per page. */
function askApp(): Promise<string | null> {
  appVersion ??= fetch('/api/about', { credentials: 'include' })
    .then((r) => (r.ok ? (r.json() as Promise<{ app?: string }>) : {}))
    .then((about: { app?: string }) => about.app ?? null)
    .catch(() => null);
  return appVersion;
}

export function BuildInfo({ product }: { product: string }): JSX.Element {
  const [app, setApp] = useState<string | null>(null);
  useEffect(() => {
    let live = true;
    void askApp().then((v) => live && setApp(v));
    return () => {
      live = false;
    };
  }, []);
  const built = BUILD.built
    ? new Date(BUILD.built).toLocaleString(undefined, { dateStyle: 'medium', timeStyle: 'short' })
    : '';
  return (
    <p className="build-info" title={built ? `Built ${built}` : undefined}>
      {app ? `${product} app ${app}` : `${product} ${BUILD.version}`} · build{' '}
      <span className="build-id">{BUILD.build}</span>
    </p>
  );
}
